var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMatchesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "matches_icon",
    "data-name": "Matches icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.738,
    height: 26.286,
    viewBox: "0 0 21.738 26.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "matches_icon-2",
    "data-name": "Matches icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    d: "M15.823,60.6l-4.814,7.554a1.738,1.738,0,0,0,.526,2.38,1.6,1.6,0,0,0,.913.277,1.667,1.667,0,0,0,1.439-.8l4.731-7.415-1.273-.609A3.227,3.227,0,0,1,15.823,60.6Z",
    transform: "translate(-10.744 -44.524)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17575",
    "data-name": "Ellipse 17575",
    cx: 3.016,
    cy: 3.016,
    r: 3.016,
    transform: "translate(13.601 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    d: "M35.062,32.242a1.756,1.756,0,0,0-.941-1.134L30.746,29.53,33.07,26.1l1.162,2.629a1.418,1.418,0,0,0,1.3.858,1.868,1.868,0,0,0,.387-.055l3.32-.913a1.437,1.437,0,0,0-.775-2.767l-2.131.581-1.024-2.324a3.875,3.875,0,0,0-1.439-1.688l-2.463-1.6a4.069,4.069,0,0,0-2.463-.636l-3.625.277a1.442,1.442,0,0,0-.968.5l-2.463,2.905a1.433,1.433,0,0,0,2.186,1.854l2.075-2.435,2.158-.166-3.127,5.561a1.784,1.784,0,0,0-.138,1.356,1.67,1.67,0,0,0,.913,1.024L30.8,33.321,28.089,37a1.721,1.721,0,0,0,2.767,2.048l3.929-5.368A1.77,1.77,0,0,0,35.062,32.242Z",
    transform: "translate(-18.556 -15.281)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17576",
    "data-name": "Ellipse 17576",
    cx: 2.629,
    cy: 2.629,
    r: 2.629,
    transform: "translate(16.257 21.001)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchesIcon);
export default __webpack_public_path__ + "static/media/MatchesIcon.b8631979c267f87c559d7b5ac1418889.svg";
export { ForwardRef as ReactComponent };